import React, { useEffect, useRef, useState } from 'react'
import * as d3 from 'd3';
import { data } from './BarData'; // Import the data array

const color = {
  current: '#32D5EB',
  next: '#E684E2',
}

const BarChart = () => {
  const chartRef = useRef();
  const tooltipRef = useRef();
  const [currentProperty, setCurrentProperty] = useState('current');
  const [currentCategory, setCurrentCategory] = useState('diversity');

  const getDimensions = () => {
    const width = window.innerWidth > 768 ? 700 : window.innerWidth * 0.9;
    const height = window.innerWidth > 768 ? 800 : 1000;
    const fontSize = window.innerWidth > 768 ? "11px" : "12px";
    return { width, height, fontSize };
  };

  const [dimensions, setDimensions] = useState(getDimensions());

  useEffect(() => {
    const handleResize = () => {
      setDimensions(getDimensions());
      drawChart();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [currentCategory]);

  useEffect(() => {
    drawChart();
  }, [currentCategory, dimensions]);

  let sortedData;

  if (currentCategory === 'populism' || currentCategory === 'diversity') {
    sortedData = [...data].sort((a, b) => a['current_' + currentCategory] - b['current_' + currentCategory]);
  } else {
    sortedData = [...data].sort((a, b) => b['current_' + currentCategory] - a['current_' + currentCategory]);
  }

  const margin = { top: 0, right: 30, bottom: 0, left: 100 };
  
  const drawChart = () => {
  // Clear existing chart
    d3.select('#chart').selectAll('*').remove();
    drawSingleChart("current");
    drawSingleChart("next");
  };

  const handleCategoryChange = (event) => {
    setCurrentCategory(event.target.value);
  };

  const drawSingleChart = (property) => {
    const filteredData = sortedData.filter(d => {
      return (d['current_' + currentCategory] !== "" && d['current_' + currentCategory] !== undefined) || (d['next_' + currentCategory] !== "" && d['next_' + currentCategory] !== undefined);
    });

    const svg = d3.select('#chart')
      .attr('viewBox', `0 0 ${dimensions.width + margin.left + margin.right} ${dimensions.height + margin.top + margin.bottom}`)
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);

    // Set up the scales
    const xScale = d3.scaleLinear()
      .domain([0, d3.max(filteredData, d => d['current_' + currentCategory])])
      .range([0, dimensions.width]);

    const yScale = d3.scaleBand()
      .domain(filteredData.map(d => d.country_cn))
      .range([0, dimensions.height])
      .padding(0.6);

    var yAxis = d3.axisLeft()
      .scale(yScale)
      .tickSize(0)
      .tickFormat(function(d, i){return filteredData[i].country_cn})

    var yText = svg.append("g")
      .attr("class", "y axis")
      .attr("transform", "translate(-8, 0 )")
      .call(yAxis)
      .style("font-size", dimensions.fontSize);

    const bars = svg.selectAll('rect')
      .data(filteredData)

    // Remove old bars
    bars.exit().remove();

    // Add the bars
    bars.enter()
      .append('rect')
      .attr('class', property)
      .attr('fill', color[property])
      .attr("transform", "translate(0, " + (property === 'current' ? -4 : 4) + ")")
      .attr('x', xScale(0))
      .attr('width', d => xScale(d[property + '_' + currentCategory]))
      .attr('y', d => yScale(d.country_cn))
      .attr('height', yScale.bandwidth())
      .on('mouseover', handleMouseOver)
      .on('mousemove', handleMouseMove)
      .on('mouseout', handleMouseOut)
      // .style('opacity', 0)
      .merge(bars)
      .transition()
      .duration(750)
      // .style('opacity', 1)

    // Add labels to bars if needed
    // bars.enter()
    //   .append("text")
    //   .attr('class', property)
    //   .attr("transform", "translate(0, " + (property === 'current' ? -4 : 4) + ")")
    //   .attr("x", d => xScale(d[property + '_' + currentCategory]) + 5)
    //   .attr("y", d => yScale(d.country_cn) + yScale.bandwidth() / 2)
    //   .text(d => d[property + '_' + currentCategory])
    //   .style("font-size", dimensions.fontSize)
    //   .attr("dy", ".35em");
  };

  const getButtonLabel = (value) => {
    const button = buttonConfigs.find(button => button.value === value);
    return button ? button.label : '';
  };

  const getPropertyLabel = (value) => {
    const property = propertyConfigs.find(property => property.value === value);
    return property ? property.label : '';
  };

  const handleMouseOver = (event, d) => {
    const property = event.target.className.baseVal;
    console.log(property)
    d3.select(tooltipRef.current)
      .style('display', 'block')
      .html(`
      <h3>${d.country_cn}</h3>
      ${property === 'current' ? `<span class="current">选举前政党：</span>${d.current_party}` : `<span class="next">选举后政党：</span>${d.next_party}`}
      <span class="${property}">${getButtonLabel(property)}${getPropertyLabel(currentCategory)}: </span>${d[property + '_' + currentCategory]}
      `);
  };

  const handleMouseMove = (event) => {
    d3.select(tooltipRef.current)
      .style('left', (event.pageX + 10) + 'px')
      .style('top', (event.pageY - 25) + 'px');
  };

  const handleMouseOut = () => {
    d3.select(tooltipRef.current)
      .style('display', 'none');
  };

  const buttonConfigs = [
    { label: '选举前', value: 'current' },
    { label: '选举后', value: 'next' },
    { label: '前后对比', value: 'compare' }
  ];

  const propertyConfigs = [
    { label: '反多元主义指数', value: 'diversity', desc: '研究机构V-研究机构V-Dem综合多个指标对各国政党的一个综合评分。政党的反多元主义指数越高，反映了该政党越趋于专制，不遵守民主过程、不尊重少数群体的基本权利，也越容易妖魔化反对党，甚至支持政治暴力。' },
    { label: '民粹主义指数', value: 'populism', desc: '研究机构V-Dem综合多个指标对各国政党的一个综合评分。政党的民粹主义指数越高，反映了该政党越倾向专制，越多利用反建制、反精英、反腐败等民粹主义言论来鼓舞民众的政治参与、建立政治和社会联盟。' },
    { label: '移民', value: 'immigrant', desc: '政党的移民政策分数越高，表面该政党越支持以各种方式来到本国的移民。' },
    { label: 'LGBT', value: 'lgbt', desc: '政党的LGBT态度分数越高，表面该政党越支持LGBT人群享有平等社会权利。' },
    { label: '女性领导比例', value: 'female', desc: ' 该指数表面女性在该党的国家级领导层所占的比例。分数越高表明该党的国家级领导中性别比列越平衡。' },
    { label: '经济政策左右立场', value: 'economy', desc: '分数越低，该政党的经济政策越偏左，往往坚持政府对经济的积极调节作用，如增税、更多法规和政府支出，以及更慷慨的社会福利政策。分数越高，政党的经济政策越偏右，越注重减少政府在经济中的作用，私有化，减税，减少规管，降低政府支出，以及精简社会福利。' }
  ];

  return (
    <>
      <div className="navigation bar">
        <div className="navigation-wrapper bar">
          {buttonConfigs.map((button, index) => (
            <button
              key={index}
              onClick={() => setCurrentProperty(button.value)}
              className={ currentProperty === button.value ? "selected" : ""}
            >
              {button.label}
            </button>
          ))}
          <select value={currentCategory} onChange={handleCategoryChange}>
            {propertyConfigs.map((property, index) => (
              <option key={index} value={property.value}>{property.label}</option>
            ))
            }
          </select>
          <div className='desc-wrapper'>
            <div className='desc'>
              {propertyConfigs.find(button => button.value === currentCategory).desc}
            </div>
          </div>
        </div>
      </div>
      <svg id="chart" className={"chart " + currentProperty} ref={chartRef}></svg>
      <div ref={tooltipRef} className="tooltip" style={{ position: 'absolute', display: 'none', pointerEvents: 'none', backgroundColor: 'white', border: '1px solid #ddd', padding: '10px 10px 15px', borderRadius: '3px', boxShadow: '0 1px 2px rgba(0, 0, 0, .1)', fontSize: '12px' }}></div>
    </>
  );
};

export default BarChart;
